/**
 * The completion dialog that appears when the user submits the one panel survey
 */
import React from "react";
import FocusTrap from "focus-trap-react";
import { Button, Modal } from "react-bootstrap";
import PropTypes from "prop-types";

const OnePanelSurveyCompletionDialog = (props) => {
  const {
    showOnePanelSurveyCompletion,
    onePanelSurveyCompletion,
    isOpen,
    handleOnClick,
    handleCloseCompletionDialog,
    bluePrintStyle,
  } = props;

  return (
    <FocusTrap
      active={isOpen && showOnePanelSurveyCompletion}
      focusTrapOptions={{
        clickOutsideDeactivates: true,
      }}
    >
      <div>
        {isOpen && showOnePanelSurveyCompletion && (
          <Modal.Dialog
            style={{
              position: "fixed",
              bottom: 0,
              right: "1rem",
              minWidth: "32em",
              zIndex: 9999999,
            }}
            role={"dialog"}
            id={"onePanelSurveyModal"}
            className={`balto-${bluePrintStyle}`}
          >
            <Modal.Header
              id={"onePanelSurveyModalHeader"}
              closeButton
              onHide={handleOnClick}
            >
              <Modal.Title
                as="h3"
                id={"onePanelSurveyModalTitle"}
                dangerouslySetInnerHTML={{
                  __html: onePanelSurveyCompletion.header,
                }}
              />
            </Modal.Header>
            <Modal.Body
              dangerouslySetInnerHTML={{
                __html: onePanelSurveyCompletion.body,
              }}
              id={"onePanelSurveyModalBody"}
            />
            <Modal.Footer data-testid={"footer"} id={"onePanelSurveyFooter"}>
              <Button variant={"primary"} onClick={handleCloseCompletionDialog}>
                {onePanelSurveyCompletion.button}
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        )}
      </div>
    </FocusTrap>
  );
};

OnePanelSurveyCompletionDialog.propTypes = {
  showOnePanelSurveyCompletion: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  handleCloseCompletionDialog: PropTypes.func.isRequired,
  bluePrintStyle: PropTypes.string,
  onePanelSurveyCompletion: PropTypes.shape({
    header: PropTypes.string,
    body: PropTypes.string,
    button: PropTypes.string,
  }),
};

export default OnePanelSurveyCompletionDialog;
